export default "__VITE_ASSET__CXSsl_EF__"